const FuelTooltipStyles = (theme) => {
  return {
    fuelTooltip: {
      width: 200,
      minWidth: 200,
      maxWidth: 200,
    },
    header: {
      fontSize: 13,
      fontWeight: 1000,
      paddingBottom: 5,
      textAlign: "center"
    },
    value: {
      fontSize: 12,
      fontWeight: 1000,
      paddingTop: 5,
    },
  }
}
export default FuelTooltipStyles;
